import { getClientEnv } from 'common/utils/frontUtils';
import { Api as BaseApi } from './generated';

const getApiBaseUrl = () => {
	const ApiUrls = {
		LOCAL: 'http://localhost:3000',
		DEV: 'https://beta.dev.api.rentle.io',
		PROD: 'https://beta.api.rentle.io',
	};
	const useEmulator = process.env.REACT_APP_USE_EMULATOR === 'true';
	const environment = getClientEnv();
	if (useEmulator) {
		return ApiUrls.LOCAL;
	}
	if (environment === 'production') {
		return ApiUrls.PROD;
	}
	return ApiUrls.DEV;
};

const baseApi = new BaseApi({
	baseUrl: getApiBaseUrl(),
});

export const Api = baseApi.v2;
